import React from "react";
import { Link } from "react-router-dom";

import {
  Mail,
  MapPin,
  Phone,
} from "lucide-react";

import useGlobalConfig from "../hooks/useGlobalConfig";

const descriptionText = `"ஸ்ரீ ப்ரம்மம் மாத இதழ்" என்பது ஆன்மிகம், சமயம், தத்துவம் மற்றும் மனித வாழ்க்கையின் உயர்ந்த அர்த்தங்களை எடுத்துரைக்கும் ஒரு சிறப்பு மாத இதழாகும்.`;

const Footer: React.FC = () => {

  const { config } =
    useGlobalConfig();

  return (
    <footer className="w-full bg-gray-100 md:bg-white">

      <div className="flex flex-col lg:flex-row w-full">

        {/* LEFT */}
        <div className="w-full lg:w-[35%] bg-gray-100 p-8 flex flex-col items-center lg:items-start justify-center">

          <div className="mb-6">
            <img
              src="/images/logo.png"
              alt="logo"
              className="h-16 md:h-20 object-contain"
            />
          </div>

          <p
            className="font-bold text-black leading-relaxed mb-6 text-center lg:text-left max-w-md"
            style={{
              fontSize: "13px",
              fontFamily:
                "'Noto Sans Tamil', sans-serif",
            }}
          >
            {descriptionText}
          </p>

          {/* SOCIAL */}
          <div className="flex gap-5 items-center">

            {config?.facebook_url && (
  <a
    href={config.facebook_url}
    target="_blank"
    rel="noreferrer"
  >
    <img
      src="/images/facebook.png"
      alt="facebook"
      className="w-8 h-8"
    />
  </a>
)}

          {config?.youtube_url && (
  <a
    href={config.youtube_url}
    target="_blank"
    rel="noreferrer"
  >
    <img
      src="/images/youtube.png"
      alt="youtube"
      className="w-8 h-8"
    />
  </a>
)}
          </div>
        </div>

     {/* RIGHT SECTION */}
{/* RIGHT SECTION */}
<div className="w-full lg:w-[65%] bg-red-700 text-white px-6 md:px-12 pt-10 pb-6">

  {/* EXPLORE & CONTACTS GRID */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

    {/* Explore Section */}
    <div className="flex flex-col items-center lg:items-start lg:ml-20 text-center lg:text-left">
      <h2 className="font-semibold mb-4 text-2xl">Explore</h2>
      <nav className="flex flex-col space-y-3">
        <Link to="/about">About</Link>
        <Link to="/issues">Editions</Link>
        <Link to="/reporters">Our Team</Link>
      </nav>
    </div>

    {/* Contact Section */}
<div className="flex flex-col items-center lg:items-start w-full">
          <h2 className="font-semibold mb-4 text-2xl">Contacts</h2>
<ul className="space-y-5 w-full max-w-[320px] mx-auto pl-14 sm:pl-16 lg:pl-0">  {/* EMAIL */}
  <li className="flex items-start gap-3">

    <Mail
      size={22}
      className="shrink-0 mt-1"
    />

   <a
  href="mailto:sribrahmamcbe@gmail.com"
  className="text-sm md:text-base break-all text-left hover:underline"
>
  sribrahmamcbe@gmail.com
</a>

  </li>

  {/* ADDRESS */}
  <li className="flex items-start gap-3">

    <MapPin
      size={22}
      className="shrink-0 mt-1"
    />

    <span className="text-sm md:text-base text-left leading-7">

      Sri Brahmam,
      <br />

      Monthly Magazine,
      <br />

      Shop No. 4, Vasavi Towers,
      <br />

      22/715, Raja Street,
      <br />

      Coimbatore - 641 001

    </span>

  </li>

  {/* PHONE */}
  <li className="flex items-start gap-3">

    <Phone
      size={22}
      className="shrink-0 mt-1"
    />

  <a
  href="tel:8825868187"
  className="text-sm md:text-base text-left hover:underline"
>
  8825868187
</a>

  </li>

</ul>
    </div>
  </div>

  {/* ஒரே ஒரு COPYRIGHT SECTION மட்டும் இங்கே இருக்க வேண்டும் (Grid-க்கு வெளியே) */}
  <div className="border-t border-red-400/50 pt-6 mt-10">
<p className="text-sm lg:text-lg text-center lg:text-left">
        © {new Date().getFullYear()} Sri Brahmam. All Rights Reserved
    </p>
  </div>

</div>
      </div>
    </footer>
  );
};

export default Footer;